export const LANG_CHANGE = 'LANG_CHANGE';
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const PLANNER_VISIBLE = 'PLANNER_VISIBLE'
export const SET_ACTIVE_STEP = 'SET_ACTIVE_STEP';
export const SET_COMPLETED_STEP = 'SET_COMPLETED_STEP';